/**
 * Add leading zero to the seconds if the value is less than 10
 * @param {number} seconds Number of seconds to format (0-59)
 * @returns {string} Formatted seconds (00-59)
 */
export const timeZero = (seconds) => {
    return seconds < 10 ? `0${seconds}` : seconds;
};
